// src/pages/website/ContactPage.js
import React, { useState } from 'react';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';
import './website.css';

export default function ContactPage() {
  const [form, setForm]       = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmit] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // For now open mailto — backend email API can be added later
    const mailto = `mailto:info@civicsetu.in?subject=${encodeURIComponent(form.subject)}&body=${encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`)}`;
    window.open(mailto);
    setSubmit(true);
  };

  return (
    <div className="website-page">
      <Navbar />

      <section style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0066cc 100%)',
        color: '#fff', padding: '60px 5%', textAlign: 'center'
      }}>
        <h1 style={{ fontSize: 40, fontWeight: 800, marginBottom: 12 }}>Contact Us</h1>
        <p style={{ fontSize: 17, opacity: 0.85 }}>We are here to help</p>
      </section>

      <section className="section">
        <div style={{ maxWidth: 800, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 40 }}>

          {/* Contact Info */}
          <div>
            <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>Get in Touch</h2>
            {[
              { icon: '📧', title: 'Email', value: 'info@civicsetu.in' },
              { icon: '🛡️', title: 'Grievance Officer', value: 'grievance@civicsetu.in' },
              { icon: '🔒', title: 'Privacy Requests', value: 'privacy@civicsetu.in' },
            ].map((c, i) => (
              <div key={i} style={{ display: 'flex', gap: 14, marginBottom: 20 }}>
                <span style={{ fontSize: 24 }}>{c.icon}</span>
                <div>
                  <div style={{ fontWeight: 600, marginBottom: 2 }}>{c.title}</div>
                  <div style={{ color: '#666', fontSize: 14 }}>{c.value}</div>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 32, padding: 20, background: '#f8faff', borderRadius: 8 }}>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>⏱️ Response Time</div>
              <div style={{ fontSize: 14, color: '#666', lineHeight: 1.6 }}>
                We respond to all queries within 24-48 hours on business days.
                For urgent matters, please mention "URGENT" in your subject line.
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            {submitted ? (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
                <h3 style={{ fontSize: 20, marginBottom: 8 }}>Message Sent!</h3>
                <p style={{ color: '#666' }}>Your email client should have opened. We will get back to you soon.</p>
                <button
                  className="web-btn web-btn-outline"
                  style={{ marginTop: 20 }}
                  onClick={() => setSubmit(false)}
                >
                  Send Another
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Your Name</label>
                  <input className="form-control" required value={form.name}
                    onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                    placeholder="Rahul Sharma" />
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" className="form-control" required value={form.email}
                    onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                    placeholder="rahul@example.com" />
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <select className="form-control" value={form.subject}
                    onChange={e => setForm(f => ({ ...f, subject: e.target.value }))}>
                    <option value="">Select subject</option>
                    <option>General Inquiry</option>
                    <option>Bulk Order Query</option>
                    <option>Technical Support</option>
                    <option>Payment Issue</option>
                    <option>Privacy Request</option>
                    <option>Grievance</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea className="form-control" rows={5} required value={form.message}
                    onChange={e => setForm(f => ({ ...f, message: e.target.value }))}
                    placeholder="How can we help you?" />
                </div>
                <button type="submit" className="web-btn web-btn-primary"
                  style={{ width: '100%', justifyContent: 'center' }}>
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
